import moment from 'moment'

const durationRegex = /(?<quantity>\d+)(?<units>.*)/

class TimedStorage {
  constructor (storage) {
    this.storage = storage
  }

  setItem (key, value, duration) {
    const { storage } = this
    const now = moment()
    try {
      const [quantity, units] = this.splitDuration(duration)
      const expiry = now.add(quantity, units).utc().valueOf()
      if (Number.isNaN(expiry)) {
        storage.setItem(key, value)
        return
      }
      const json = {
        expiry,
        value
      }
      storage.setItem(key, JSON.stringify(json))
    } catch (e) {
      storage.setItem(key, value)
    }
  }

  splitDuration (duration) {
    const match = durationRegex.exec(duration)
    if (!match || !match.groups) {
      throw new Error('Invalid duration')
    }
    const { groups: { quantity, units } } = match
    return [quantity, units]
  }

  getItem (key, returnExpiredValue = false) {
    const { storage } = this
    const data = storage.getItem(key)
    try {
      const json = JSON.parse(data)
      const { expiry, value } = json
      const now = moment().utc().valueOf()
      if (!expiry) {
        return value
      }
      const expired = now > expiry
      if (!returnExpiredValue && expired) {
        storage.removeItem(key)
        return null
      }
      return value
    } catch (e) {
      return data
    }
  }

  getJSON (key) {
    const { storage } = this
    const data = storage.getItem(key)
    try {
      const json = JSON.parse(data)
      return json
    } catch (e) {
      return null
    }
  }

  getExpiry (key) {
    const json = this.getJSON(key)
    if (!json) {
      return null
    }
    return json.expiry
  }
}

export default TimedStorage
